import { Button } from '@components/Button';
import { Four04 } from '@components/Illustrations';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import NullResultsMessage from '../';
import { ButtonContainer, IllustrationWrapper, NullContainer } from '../styles';

interface NullResultsSearchListingsProps {
  header: string;
  bodyText: string;
  isSVG?: boolean;
  newSearchUrl?: string;
  findAdvisorUrl?: string;
  onBeginNewSearchBtnClicked?: () => void;
  onFindAdvisorBtnClicked?: () => void;
  isShopPage?: boolean;
}

const NullResultsSearchListings: FC<NullResultsSearchListingsProps> = ({
  header,
  bodyText,
  newSearchUrl,
  findAdvisorUrl,
  isSVG,
  isShopPage,
  onBeginNewSearchBtnClicked,
  onFindAdvisorBtnClicked,
}) => {
  const t = useTranslations();

  return (
    <NullContainer>
      <NullResultsMessage isSVG={isSVG} header={header} bodyText={bodyText} />

      <ButtonContainer>
        {(newSearchUrl || onBeginNewSearchBtnClicked) && (
          <Button
            url={newSearchUrl}
            label={isShopPage ? t('Additional Neighborhoods') : t('Begin a New Search')}
            variant="secondary"
            arrow={false}
            onClickHandler={onBeginNewSearchBtnClicked}
          />
        )}
        {(findAdvisorUrl || onFindAdvisorBtnClicked) && (
          <Button
            url={findAdvisorUrl}
            label={t('Find an Advisor')}
            variant="secondary"
            arrow={false}
            onClickHandler={onFindAdvisorBtnClicked}
          />
        )}
      </ButtonContainer>

      <IllustrationWrapper>
        <Four04 />
      </IllustrationWrapper>
    </NullContainer>
  );
};

export default NullResultsSearchListings;
